// extracted by mini-css-extract-plugin
export var event_intro = "private-events-module--event_intro--dz8V+";
export var events_list = "private-events-module--events_list--6Q07T";
export var form_footer = "private-events-module--form_footer--BM4Yb";
export var header_bg = "private-events-module--header_bg--9DBlp";
export var hidden = "private-events-module--hidden--IvECv";
export var private_events_form = "private-events-module--private_events_form--PCYJv";
export var private_events_list = "private-events-module--private_events_list--+ooTm";
export var required = "private-events-module--required--+clu1";